import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

interface PageTitleProps {
    children: React.ReactNode;
    variant?: TypographyProps['variant'];
    sx?: TypographyProps['sx'];
}

const PageTitle = ({ 
    children, 
    variant = 'h5',
    sx = {},
}: PageTitleProps) => {
    return (
        <Typography
            variant={variant}
            component="h1"
            sx={{
                mb: 2,
                fontWeight: 600,
                color: 'text.primary',
                ...sx,
            }}
        >
            {children}
        </Typography>
    );
};

export default PageTitle;
